module.exports = __webpack_public_path__ + "static/media/Headshot.dce51ce0.jpg";